import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { UserContextProvider } from "./Context/UserContext";
import { PageTitleContextProvider } from "./Context/PageTitleContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserContextProvider>
    <PageTitleContextProvider>
      <App />
    </PageTitleContextProvider>
  </UserContextProvider>,
);
